module.exports = __webpack_public_path__ + "static/media/none.cfdbafe3.png";